function initBookingButton(element) {
    if (element.hasAttribute('data-booking-initialized')) {
        return;
    }

    element.setAttribute('data-booking-initialized', true);
    element.addEventListener('click', function (e) {
        e.preventDefault();

        let configuration = JSON.parse(this.getAttribute('data-booking-configuration'));
        configuration.iframeId = 'booxi-iframe-' + Date.now().toString(36) + Math.random().toString(36).substr(2);
        configuration.googleTag = function () {
            window.dataLayer.push(arguments);
        }
        configuration.googleTagEventFormat = 'GA4';
        configuration.onClose = function (data) {
            if ('Booked' !== data.bookNowStatus) {
                return;
            }

            let bookingConfirmedBooxiDataLayer = {
                event: 'custom_booking_confirmed_booxi',
                shop_name: data.bizName,
                booking_id: data.bookingId,
                user_data: {
                    email_address: data.client.email,
                    phone_number: data.client.mobilePhoneNumber.replace('+', '')
                }
            };

            if (null !== element.getAttribute('data-booking-product-name')) {
                bookingConfirmedBooxiDataLayer.item_name = element.getAttribute('data-booking-product-name');
            }

            if (null !== document.querySelector('meta[name="user-id"]')) {
                bookingConfirmedBooxiDataLayer.lead_id = document.querySelector('meta[name="user-id"]').getAttribute('content');
            }

            window.dataLayer.push(bookingConfirmedBooxiDataLayer);
        }

        BookNow.open(configuration);
    })
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-booking-configuration]').forEach(function (element) {
        initBookingButton(element);
    })
})

var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length >= 1) {
            for (var i = 0; i < mutation.addedNodes.length; i++) {
                if (undefined !== mutation.addedNodes[i].localName) {
                    mutation.addedNodes[i].querySelectorAll('[data-booking-configuration]').forEach(function (element) {
                        initBookingButton(element);
                    })
                }
            }
        }
    });
});

observer.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });